export default __webpack_public_path__ + "static/job-in-progress-c71f4c4fe480ec8d2f085513891b9cfc.png";